export default "__VITE_ASSET__DDuqoma3__"